module.exports = __webpack_public_path__ + "img/target.13bd490a.svg";